export default "__VITE_ASSET__DwD14kMm__"